import DailyProduction from './daily-production.container'

export default DailyProduction
